<section class="content head">
  <div class="content-wrapper audit-details">
    <h1 class="audit-details__header">Audit Report</h1>
    <iaud-breadcrumb class="audit-details__breadcrumbs" [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
    <div class="audit-details__buttons" *ngIf="audit.status === auditStatus.DRAFT">
      <button mat-raised-button class="inverted right-margin" routerLink="/audit">Finish Later</button>
      <button mat-raised-button [color]="'accent'" [disabled]="!audit.canSubmit" (click)="submitAudit()">Submit</button>
    </div>
    <mat-card class="audit-details__panel">
      <div class="audit-details__panel__header">
        <mat-card-title>Audit Details</mat-card-title>
        <div>
          <button mat-raised-button class="edit-button" (click)="editAudit()" *ngIf="(audit.status === auditStatus.DRAFT || canUpdate) && !isCompleted">Edit</button>
          <button mat-raised-button class="edit-button" (click)="showAuditHistory()" *ngIf="(audit.status === auditStatus.DRAFT || canUpdate) && hasHistory">History</button>
        </div>
      </div>

      <div class="audit-details__panel__values">
        <div class="audit-details__panel__values--id iaud-value-container">
          <label for="audit-id">Audit id:</label>
          <p id="audit-id">{{ audit.auditId }}</p>
        </div>

        <div class="audit-details__panel__values--code iaud-value-container">
          <label for="audit-code">Audit code:</label>
          <p id="audit-code">{{ audit.auditCode }}</p>
        </div>

        <div class="audit-details__panel__values--title iaud-value-container">
          <label for="audit-title">Audit title:</label>
          <p id="audit-title">{{ audit.auditTitle }}</p>
        </div>

        <div class="audit-details__panel__values--type iaud-value-container">
          <label for="audit-type">Audit type:</label>
          <p id="audit-type">{{ audit.auditType }}</p>
        </div>

        <div class="audit-details__panel__values--owner-group iaud-value-container">
          <label for="audit-owner-group">Audit owner group:</label>
          <p id="audit-owner-group">{{ audit.auditOwnerGroup }}</p>
        </div>

        <div class="audit-details__panel__values--sme iaud-value-container">
          <label for="audit-sme">Subject matter expert (sme):</label>
          <p id="audit-sme" *ngFor="let approver of audit.smeApprovers">
            {{ approver.fullName }}
          </p>
        </div>

        <div class="audit-details__panel__values--external iaud-value-container">
          <label for="audit-external-partner">External business partner:</label>
          <p id="audit-external-partner">{{ audit.externalPartner }}</p>
        </div>

        <div class="audit-details__panel__values--due-date iaud-value-container">
          <label for="audit-due-date">Audit due date</label>
          <p id="audit-due-date">{{ audit.dueDate | date:dateFormat }}</p>
        </div>

        <div class="audit-details__panel__values--status iaud-value-container">
          <label for="audit-status">Audit status:</label>
          <p id="audit-status">{{ audit.status }}</p>
        </div>

        <div class="audit-details__panel__values--description iaud-value-container description">
          <label for="audit-description">Audit description:</label>
          <p id="audit-description">{{ audit.auditDescription }}</p>
        </div>
      </div>
    </mat-card>
  </div>
</section>
<iaud-finding-list [auditId]="audit.id" [reloadFinding]="reloadFinding" [auditStatus]="audit.status"></iaud-finding-list>
